/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlayerPerformanceStatistic } from './PlayerPerformanceStatistic';
import {
    PlayerPerformanceStatisticFromJSON,
    PlayerPerformanceStatisticFromJSONTyped,
    PlayerPerformanceStatisticToJSON,
    PlayerPerformanceStatisticToJSONTyped,
} from './PlayerPerformanceStatistic';
import type { TeamMatchResult } from './TeamMatchResult';
import {
    TeamMatchResultFromJSON,
    TeamMatchResultFromJSONTyped,
    TeamMatchResultToJSON,
    TeamMatchResultToJSONTyped,
} from './TeamMatchResult';
import type { TeamPerformanceStatistic } from './TeamPerformanceStatistic';
import {
    TeamPerformanceStatisticFromJSON,
    TeamPerformanceStatisticFromJSONTyped,
    TeamPerformanceStatisticToJSON,
    TeamPerformanceStatisticToJSONTyped,
} from './TeamPerformanceStatistic';
import type { TournamentCategory } from './TournamentCategory';
import {
    TournamentCategoryFromJSON,
    TournamentCategoryFromJSONTyped,
    TournamentCategoryToJSON,
    TournamentCategoryToJSONTyped,
} from './TournamentCategory';
import type { TeamStatistic } from './TeamStatistic';
import {
    TeamStatisticFromJSON,
    TeamStatisticFromJSONTyped,
    TeamStatisticToJSON,
    TeamStatisticToJSONTyped,
} from './TeamStatistic';
import type { PlayerScoreStatistic } from './PlayerScoreStatistic';
import {
    PlayerScoreStatisticFromJSON,
    PlayerScoreStatisticFromJSONTyped,
    PlayerScoreStatisticToJSON,
    PlayerScoreStatisticToJSONTyped,
} from './PlayerScoreStatistic';

/**
 * 
 * @export
 * @interface TeamTournamentStatistics
 */
export interface TeamTournamentStatistics {
    /**
     * 
     * @type {Array<PlayerPerformanceStatistic>}
     * @memberof TeamTournamentStatistics
     */
    playerStatistics?: Array<PlayerPerformanceStatistic>;
    /**
     * 
     * @type {Array<PlayerPerformanceStatistic>}
     * @memberof TeamTournamentStatistics
     */
    goalkeeperStatistics?: Array<PlayerPerformanceStatistic>;
    /**
     * 
     * @type {Array<TeamPerformanceStatistic>}
     * @memberof TeamTournamentStatistics
     */
    teamPerformance?: Array<TeamPerformanceStatistic>;
    /**
     * 
     * @type {string}
     * @memberof TeamTournamentStatistics
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamTournamentStatistics
     */
    teamName?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamTournamentStatistics
     */
    tournamentId?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamTournamentStatistics
     */
    tournamentName?: string;
    /**
     * 
     * @type {TournamentCategory}
     * @memberof TeamTournamentStatistics
     */
    category?: TournamentCategory;
    /**
     * 
     * @type {TeamStatistic}
     * @memberof TeamTournamentStatistics
     */
    overallStats?: TeamStatistic;
    /**
     * 
     * @type {Array<TeamMatchResult>}
     * @memberof TeamTournamentStatistics
     */
    matches?: Array<TeamMatchResult>;
    /**
     * 
     * @type {Array<PlayerScoreStatistic>}
     * @memberof TeamTournamentStatistics
     */
    topScorers?: Array<PlayerScoreStatistic>;
    /**
     * 
     * @type {string}
     * @memberof TeamTournamentStatistics
     */
    groupName?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamTournamentStatistics
     */
    stageName?: string;
    /**
     * 
     * @type {number}
     * @memberof TeamTournamentStatistics
     */
    currentPosition?: number;
}

/**
 * Check if a given object implements the TeamTournamentStatistics interface.
 */
export function instanceOfTeamTournamentStatistics(value: object): value is TeamTournamentStatistics {
    return true;
}

export function TeamTournamentStatisticsFromJSON(json: any): TeamTournamentStatistics {
    return TeamTournamentStatisticsFromJSONTyped(json, false);
}

export function TeamTournamentStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamTournamentStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'playerStatistics': json['playerStatistics'] == null ? undefined : ((json['playerStatistics'] as Array<any>).map(PlayerPerformanceStatisticFromJSON)),
        'goalkeeperStatistics': json['goalkeeperStatistics'] == null ? undefined : ((json['goalkeeperStatistics'] as Array<any>).map(PlayerPerformanceStatisticFromJSON)),
        'teamPerformance': json['teamPerformance'] == null ? undefined : ((json['teamPerformance'] as Array<any>).map(TeamPerformanceStatisticFromJSON)),
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
        'tournamentId': json['tournamentId'] == null ? undefined : json['tournamentId'],
        'tournamentName': json['tournamentName'] == null ? undefined : json['tournamentName'],
        'category': json['category'] == null ? undefined : TournamentCategoryFromJSON(json['category']),
        'overallStats': json['overallStats'] == null ? undefined : TeamStatisticFromJSON(json['overallStats']),
        'matches': json['matches'] == null ? undefined : ((json['matches'] as Array<any>).map(TeamMatchResultFromJSON)),
        'topScorers': json['topScorers'] == null ? undefined : ((json['topScorers'] as Array<any>).map(PlayerScoreStatisticFromJSON)),
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'stageName': json['stageName'] == null ? undefined : json['stageName'],
        'currentPosition': json['currentPosition'] == null ? undefined : json['currentPosition'],
    };
}

export function TeamTournamentStatisticsToJSON(json: any): TeamTournamentStatistics {
    return TeamTournamentStatisticsToJSONTyped(json, false);
}

export function TeamTournamentStatisticsToJSONTyped(value?: TeamTournamentStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'playerStatistics': value['playerStatistics'] == null ? undefined : ((value['playerStatistics'] as Array<any>).map(PlayerPerformanceStatisticToJSON)),
        'goalkeeperStatistics': value['goalkeeperStatistics'] == null ? undefined : ((value['goalkeeperStatistics'] as Array<any>).map(PlayerPerformanceStatisticToJSON)),
        'teamPerformance': value['teamPerformance'] == null ? undefined : ((value['teamPerformance'] as Array<any>).map(TeamPerformanceStatisticToJSON)),
        'teamId': value['teamId'],
        'teamName': value['teamName'],
        'tournamentId': value['tournamentId'],
        'tournamentName': value['tournamentName'],
        'category': TournamentCategoryToJSON(value['category']),
        'overallStats': TeamStatisticToJSON(value['overallStats']),
        'matches': value['matches'] == null ? undefined : ((value['matches'] as Array<any>).map(TeamMatchResultToJSON)),
        'topScorers': value['topScorers'] == null ? undefined : ((value['topScorers'] as Array<any>).map(PlayerScoreStatisticToJSON)),
        'groupName': value['groupName'],
        'stageName': value['stageName'],
        'currentPosition': value['currentPosition'],
    };
}

